import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {AuthService} from '../../core/services/auth.service';


@Injectable({providedIn: 'root'})
export class KfDataEntryGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    let allowed = false;

    if (this.authService.isLoggedIn()) {
      allowed = (this.authService.userHasAnyRole(['WF_ADMIN', 'WS_ADMIN', 'WS_COUNTRY_COORDINATOR', 'SIMPLE_USER']));
      if (state.url.includes('country') && !this.authService.userHasAnyRole(['WS_COUNTRY_COORDINATOR'])) {
        allowed = false;
      }
      if (!allowed) {
        this.router.navigate(['forbidden']);
      }
      /* Comment because SIMPLE_USER not able to see kfregistration except summary-mapping
      if (state.url.includes('kfconfiguration') && this.authService.userHasAnyRole(['SIMPLE_USER'])) {
        this.router.navigate(['/kfdataentry/weeesystem/kfregistration/all']);
      }*/
      return allowed;
    }

    // not logged in so redirect to login page with the return url
    this.router.navigate(['/login'], {queryParams: {returnUrl: state.url}});
    return false;
  }
}
